module.exports = __webpack_public_path__ + "img/icon-meteo-2@2x.51448001.png";